/**
 * Validates email address using a pattern based on RFC 5322 / HTML5 specification.
 * This is more robust than simple regex while remaining practical.
 *
 * Valid: user@domain.com, user.name+tag@sub.domain.co.uk
 * Invalid: @domain.com, user@, user@.com, user@domain., spaces
 */
export const isValidEmail = (email: string): boolean => {
  // Based on HTML5 email validation pattern (RFC 5322 simplified)
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  return emailRegex.test(email);
};

export interface PasswordValidationResult {
  isValid: boolean;
  errors: string[];
}

export const validatePassword = (password: string): PasswordValidationResult => {
  const errors: string[] = [];

  if (password.length < 11) {
    errors.push('Password must be at least 11 characters');
  }
  if (!/[0-9]/.test(password)) {
    errors.push('Password must contain at least 1 number');
  }
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) {
    errors.push('Password must contain at least 1 special character');
  }
  if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least 1 uppercase letter');
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};
